import { HitStatus, QuickSearch, SearchVersion } from "aderant-conflicts-models";
import { HitStatusComboBoxWrapper } from "components/HitStatusComboBox/HitStatusComboBoxWrapper";
import { FeatureBySearchTypeHelper } from "pages/Shared/FeatureBySearchType";
import { UserChangePermissions } from "pages/ResultsPage/ResultsPage";
import { HitResult } from "pages/ResultsPage/HitResult";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "MyTypes";
import { conflictsPalette } from "styles/conflictsPalette";
import { AderantTheme } from "@aderant/aderant-react-components";

export type HitDetailFooterProps = {
    data?: HitResult;
    searchVersion?: SearchVersion | QuickSearch;
    searchReadOnly?: boolean;
    userChangePermissions: UserChangePermissions;
    onHitChange?: (status?: HitStatus, hitOwnerId?: string | null) => void;
    hasReviewerRole?: boolean;
};

const footerStyles = {
    label: {
        color: conflictsPalette.text.disabled,
        fontSize: AderantTheme.typography.pxToRem(12),
        lineHeight: AderantTheme.typography.pxToRem(16),
        marginBottom: AderantTheme.spacing(1)
    }
} as const;

export const HitDetailFooter = (props: HitDetailFooterProps) => {
    const { data, onHitChange, searchVersion, userChangePermissions, searchReadOnly, hasReviewerRole } = props;
    const reviewerSharedStatuses = useSelector((state: RootState) => {
        const hitShared = state?.admin?.reviewerOptions?.hitShared;
        return Array.isArray(hitShared) ? hitShared : [];
    });

    const hitReadOnly = hasReviewerRole && data?.hitStatus ? !reviewerSharedStatuses.includes(data.hitStatus) : false;

    // Memoized check for whether to show hit status
    const shouldShowHitStatus = useMemo(() => {
        return FeatureBySearchTypeHelper.showHitStatus(searchVersion);
    }, [searchVersion]);

    // Early return if hit status should not be shown
    if (!shouldShowHitStatus) {
        return null;
    }

    // Render hit status component
    const renderHitStatusControl = () => {
        if (!data?.hitStatus) {
            return null;
        }

        return (
            <HitStatusComboBoxWrapper
                id="hit-status-dropdown"
                disabled={searchReadOnly || !userChangePermissions.hitStatus || hitReadOnly}
                hitStatus={data.hitStatus}
                searchVersion={searchVersion}
                onStatusChange={onHitChange}
                style={{ width: "100%" }}
            />
        );
    };

    return (
        <div>
            <div style={footerStyles.label}>Hit Status</div>
            <div>{renderHitStatusControl()}</div>
        </div>
    );
};
